import React, { useEffect, useState } from 'react';
import { Box, Grid, Typography } from '@mui/material';

import { ButtonUI, DataGridIdentifiers, DialogUI, DatagridPremiumUi } from '../Interface';
import useConfig from '../../context/ConfigContext';
import itemService from '../../service/item.service';
import { formatCurrency } from '../../utils/currencyHelper';
import { dataGridPremiumColumns } from '../../utils/helper';

const ItemStockDialog = ({ open, onClose = () => {}, data, showPrice = true }) => {
  const { getConfig, config } = useConfig();

  const [priceData, setPriceData] = useState({});
  const [rows, setRows] = useState([]);

  const getData = async () => {
    if (!data?.itemCode) return;
    const [calculatedPrice, stockRes] = await Promise.all([
      itemService.getCalculatedPrice(data.itemCode),
      itemService.getItemStock(data.itemCode),
    ]);

    setRows(stockRes);
    setPriceData(calculatedPrice);
  };

  useEffect(() => {
    if (Object.keys(config).length === 0) getConfig();
  }, []);

  useEffect(() => {
    if (open) {
      getData();
    } else {
      setPriceData({});
      setRows([]);
    }
  }, [open]);

  const columns = dataGridPremiumColumns([
    {
      field: 'itemCode',
      headerName: 'Cikkszám',
      type: 'string',
    },
    {
      field: 'whsCode',
      headerName: 'Raktár',
      type: 'string',
      groupable: true,
    },
    {
      field: 'binCode',
      headerName: 'Rakhely',
      type: 'string',
      groupable: true,
    },
    {
      field: 'batchSn',
      headerName: 'Sarzs',
      type: 'string',
      groupable: true,
    },
    {
      field: 'effectiveQty',
      headerName: 'Készlet',
      type: 'number',
      renderCell: (params) => (
        <Typography variant="body1" color="text.secondary">
          {params.value} {data?.quantityUnit?.code}
        </Typography>
      ),
    },
  ]);
  /*
return {
        itemCode: itemCode,
        currentWac: avaragePrice?.currentWac ?? 0,
        stockValue: avaragePrice?.stockValue ?? 0,
        lastPurchasePrice: lastPurchasePrice?.lastPurchasePrice ?? 0,
      };
*/
  return (
    <DialogUI open={open} onClose={onClose} headerContent={'Készlet információ'} maxWidth="lg" fullWidth>
      <Box sx={{ mt: 2 }}>
        <Grid container spacing={1} mb={2} sx={{ background: '#E9F5FE', borderRadius: '4px', p: '0.5rem' }}>
          <Grid item xs={12} md={6}>
            <Grid container spacing={0.5} alignItems="center">
              <Grid item xs={4}>
                <Typography variant="body2" color="text.secondary" sx={{ fontWeight: 700 }}>
                  Cikkszám:
                </Typography>
              </Grid>
              <Grid item xs={8}>
                <Typography variant="body1" color="text.secondary">
                  {data?.itemCode}
                </Typography>
              </Grid>
            </Grid>
          </Grid>
          <Grid item xs={12} md={6}>
            <Grid container spacing={0.5} alignItems="center">
              <Grid item xs={4}>
                <Typography variant="body2" color="text.secondary" sx={{ fontWeight: 700 }}>
                  Készleten:
                </Typography>
              </Grid>
              <Grid item xs={8}>
                <Typography variant="body1" color="text.secondary">
                  {priceData?.onHand} {data?.quantityUnit?.code}
                </Typography>
              </Grid>
            </Grid>
          </Grid>
          <Grid item xs={12}>
            <Grid container spacing={0.5} alignItems="center">
              <Grid item xs={2}>
                <Typography variant="body2" color="text.secondary" sx={{ fontWeight: 700 }}>
                  Cikknév:
                </Typography>
              </Grid>
              <Grid item xs={10}>
                <Typography variant="body1" color="text.secondary">
                  {data?.itemName}
                </Typography>
              </Grid>
            </Grid>
          </Grid>
          {showPrice && (
            <>
              <Grid item xs={12} md={6}>
                <Grid container spacing={0.5} alignItems="center">
                  <Grid item xs={4}>
                    <Typography variant="body2" color="text.secondary" sx={{ fontWeight: 700 }}>
                      Mérlegelt átlagár:
                    </Typography>
                  </Grid>
                  <Grid item xs={8}>
                    <Typography variant="body1" color="text.secondary">
                      {priceData?.currentWac
                        ? `${formatCurrency(priceData?.currentWac, 2)} ${config.currencyCode}`
                        : '-'}
                    </Typography>
                  </Grid>
                </Grid>
              </Grid>
              <Grid item xs={12} md={6}>
                <Grid container spacing={0.5} alignItems="center">
                  <Grid item xs={4}>
                    <Typography variant="body2" color="text.secondary" sx={{ fontWeight: 700 }}>
                      Utolsó beszerzési ár:
                    </Typography>
                  </Grid>
                  <Grid item xs={8}>
                    <Typography variant="body1" color="text.secondary">
                      {priceData?.lastPurchasePrice
                        ? `${formatCurrency(priceData?.lastPurchasePrice, 0)} ${config.currencyCode}`
                        : '-'}
                    </Typography>
                  </Grid>
                </Grid>
              </Grid>
            </>
          )}
        </Grid>

        <DatagridPremiumUi
          datagridIdentifier={DataGridIdentifiers.ItemStockTable}
          height={480}
          columns={columns}
          rows={rows}
          getRowHeight={() => 'auto'}
        />
      </Box>

      <Box sx={{ mt: 3, display: 'flex', justifyContent: 'center', gap: 2 }}>
        <ButtonUI text="Bezár" className="bg-success" onClick={onClose} />
      </Box>
    </DialogUI>
  );
};

export default ItemStockDialog;
